/* eslint-disable max-len */
const baseUrls = {
  vezeetaBusinessGatewayVezeetaApiBaseUrl: `${process.env.REACT_APP_VEZEETA_BUSINESS_API_GATEWAY_BASE_URL}/vezeeta-api/api`,
  vezeetaBusinessGatewayBusinessApiBaseUrl: `${process.env.REACT_APP_VEZEETA_BUSINESS_API_GATEWAY_BASE_URL}/insurance-business/api`,
  pharmacyGatewayInventoryApiBaseUrl: `${process.env.REACT_APP_PHARMACY_API_GATEWAY_BASE_URL}/inventory/api`,
  pharmacyGatewayOrderApiBaseUrl: `${process.env.REACT_APP_PHARMACY_API_GATEWAY_BASE_URL}/orders/api`,
  pharmacyGatewayPapiWebApiBaseUrl: `${process.env.REACT_APP_PHARMACY_API_GATEWAY_BASE_URL}/papi-web/api`,
};

const urls = {
  commonUrls: {
    getDropdowns: `${baseUrls.vezeetaBusinessGatewayVezeetaApiBaseUrl}/generic/getdropdowns`,
  },
  generalUrls: {
    submitRegisterForm: `${baseUrls.vezeetaBusinessGatewayBusinessApiBaseUrl}/business`,
  },
  orderUrls: {
    getUserAddress: `${baseUrls.pharmacyGatewayPapiWebApiBaseUrl}/Addresses`,
    addUserAddress: `${baseUrls.pharmacyGatewayPapiWebApiBaseUrl}/v2/Addresses`,
    searchProducts: `${baseUrls.pharmacyGatewayInventoryApiBaseUrl}/V2/ProductShapes`,
    submitOrderBulk: `${baseUrls.pharmacyGatewayOrderApiBaseUrl}/orders/bulk`,
    uploadOrderAttachments: `${baseUrls.pharmacyGatewayOrderApiBaseUrl}/fileuploads`,
  },
  accountManagementUrls: {
    requestOTP: `${baseUrls.pharmacyGatewayPapiWebApiBaseUrl}/PatientProfile/RequestOTP`,
    signWithOTP: `${baseUrls.pharmacyGatewayPapiWebApiBaseUrl}/PatientProfile/SignInWithOTP`,
    getLoginInfo: `${baseUrls.pharmacyGatewayPapiWebApiBaseUrl}/PatientProfile/GetPatientProfileData`,
  },
};

export default urls;
